"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
var _reactTable = require("@tanstack/react-table");
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _Empty = require("../empty/Empty");
var _Checkbox = require("../forms/Checkbox");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _Frow = require("../layout/Frow");
var _Spinner = require("../spinner/Spinner");
var _Tooltip = require("../tooltip/Tooltip");
var _typography = require("../typography/typography");
var _Pagination = require("./Pagination");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var scrollPositionToClassMap = {
  none: _classes.Classes.TABLE_SCROLL_NONE,
  start: _classes.Classes.TABLE_SCROLL_START,
  scrolling: _classes.Classes.TABLE_SCROLL_SCROLLING,
  end: _classes.Classes.TABLE_SCROLL_END
};
function Table(_ref) {
  var table = _ref.table,
    _ref$tableHeight = _ref.tableHeight,
    tableHeight = _ref$tableHeight === void 0 ? '100%' : _ref$tableHeight,
    _ref$showPagination = _ref.showPagination,
    showPagination = _ref$showPagination === void 0 ? true : _ref$showPagination,
    expandedRowContent = _ref.expandedRowContent,
    _ref$enableColumnPinn = _ref.enableColumnPinning,
    enableColumnPinning = _ref$enableColumnPinn === void 0 ? true : _ref$enableColumnPinn,
    pinnedColumns = _ref.pinnedColumns,
    _ref$density = _ref.density,
    density = _ref$density === void 0 ? 'default' : _ref$density,
    _ref$manualPagination = _ref.manualPagination,
    manualPagination = _ref$manualPagination === void 0 ? false : _ref$manualPagination,
    _ref$totalRows = _ref.totalRows,
    totalRows = _ref$totalRows === void 0 ? 0 : _ref$totalRows,
    _ref$isInitialLoading = _ref.isInitialLoading,
    isInitialLoading = _ref$isInitialLoading === void 0 ? false : _ref$isInitialLoading,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$tableLayout = _ref.tableLayout,
    tableLayout = _ref$tableLayout === void 0 ? 'fixed' : _ref$tableLayout;
  var _React$useState = React.useState('none'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    scrollPosition = _React$useState2[0],
    setScrollPosition = _React$useState2[1];
  var _table$getState = table.getState(),
    pagination = _table$getState.pagination;
  var hasVisibleDataColumns = table.getAllLeafColumns().some(function (col) {
    var _col$columnDef$meta;
    return col.getIsVisible() && ((_col$columnDef$meta = col.columnDef.meta) === null || _col$columnDef$meta === void 0 ? void 0 : _col$columnDef$meta.isDataColumn) !== false;
  });

  // For debugging: Log selected rows whenever selection changes

  // React.useEffect(() => {
  //   const selectedRows = table.getRowModel().rows.filter(r => r.getIsSelected());
  //   console.log(
  //     'Selected rows:',
  //     selectedRows.map(r => r.id),
  //   );
  // }, [
  //   table
  //     .getRowModel()
  //     .rows.map(r => r.getIsSelected())
  //     .join(','),
  // ]);
  // // ...existing code...

  // // Log selected rows whenever selection changes
  // React.useEffect(() => {
  //   const selectedRows = table.getRowModel().rows.filter(r => r.getIsSelected());
  //   console.log(
  //     'Selected rows:',
  //     selectedRows.map(r => r.id),
  //   );
  // }, [
  //   table
  //     .getRowModel()
  //     .rows.map(r => r.getIsSelected())
  //     .join(','),
  // ]);

  /**
   * Helpers
   */

  /**
   * Check if a column is a data column
   */
  function isDataColumn(col) {
    var _col$columnDef$meta2;
    return ((_col$columnDef$meta2 = col.columnDef.meta) === null || _col$columnDef$meta2 === void 0 ? void 0 : _col$columnDef$meta2.isDataColumn) !== false;
  }

  /**
   * Check if we want to truncate a header
   */
  function isHeaderTruncated(col) {
    var _col$columnDef$meta3;
    return ((_col$columnDef$meta3 = col.columnDef.meta) === null || _col$columnDef$meta3 === void 0 ? void 0 : _col$columnDef$meta3.truncateHeader) === true;
  }

  /**
   * Calculate pinned column offsets
   */
  var pinned = pinnedColumns !== null && pinnedColumns !== void 0 ? pinnedColumns : {};
  var allColumns = React.useMemo(function () {
    return table.getAllLeafColumns();
  }, [table]);
  var pinnedOffsets = React.useMemo(function () {
    var _pinned$left, _pinned$right;
    var colMap = new Map(allColumns.map(function (col) {
      return [col.id, col];
    }));
    var offsets = {};
    var leftOffset = 0;
    ((_pinned$left = pinned.left) !== null && _pinned$left !== void 0 ? _pinned$left : []).forEach(function (id) {
      var col = colMap.get(id);
      if (!col) return;
      offsets[id] = {
        value: 'left',
        offset: leftOffset
      };
      leftOffset += col.getSize();
    });
    var rightOffset = 0;
    var reversedRight = _toConsumableArray((_pinned$right = pinned.right) !== null && _pinned$right !== void 0 ? _pinned$right : []).reverse();
    reversedRight.forEach(function (id) {
      var col = colMap.get(id);
      if (!col) return;
      rightOffset += col.getSize();
      offsets[id] = {
        value: 'right',
        offset: rightOffset - col.getSize()
      };
    });
    return offsets;
  }, [allColumns, pinned.left, pinned.right]);

  // Track last selected row index for shift-select
  var lastSelectedIndexRef = React.useRef(null);

  /**
   * Return pinned styles and classes for a given column
   */
  function getPinnedProps(columnId) {
    var pinnedData = pinnedOffsets[columnId];
    if (!pinnedData) return {
      pinnedValue: '',
      pinnedStyles: {},
      pinnedClasses: ''
    };
    var value = pinnedData.value,
      offset = pinnedData.offset;
    var pinnedStyles = {};
    if (value === 'left') {
      pinnedStyles.left = "".concat(offset, "px");
    } else if (value === 'right') {
      pinnedStyles.right = "".concat(offset, "px");
    }
    return {
      pinnedValue: value,
      pinnedStyles: pinnedStyles,
      pinnedClasses: "pinned-".concat(value)
    };
  }

  /**
   * Get column width styles
   */
  function getColumnWidth(column) {
    var width = column.getSize();
    var minWidth = column.columnDef.minSize;
    return _objectSpread({
      width: "".concat(width, "px")
    }, typeof minWidth === 'number' ? {
      minWidth: "".concat(minWidth, "px")
    } : {});
  }

  /**
   * Get column header label
   */
  function getHeaderLabel(header) {
    var label = header.column.columnDef.header;
    return typeof label === 'string' ? label : 'Column';
  }

  /**
   * Get aria-sort value for accessibility
   */
  function getAriaSort(column) {
    var sort = column.getIsSorted();
    if (sort === 'asc') return 'ascending';
    if (sort === 'desc') return 'descending';
    return 'none';
  }

  /**
   * Combine row classes based on state
   */
  function getRowClass(_ref2) {
    var isExpanded = _ref2.isExpanded,
      isSelected = _ref2.isSelected;
    return [_classes.Classes.TABLE_ROW, isExpanded && _classes.Classes.TABLE_EXPANDED_ROW, isSelected && _classes.Classes.TABLE_SELECTED_ROW].filter(Boolean).join(' ');
  }

  /**
   * Handle horizontal table scroll, shadow states
   */
  var handleScroll = function handleScroll(event) {
    var _event$target = event.target,
      scrollLeft = _event$target.scrollLeft,
      scrollWidth = _event$target.scrollWidth,
      clientWidth = _event$target.clientWidth;

    // Check for horizontal scroll if content overflows horizontally
    if (scrollWidth > clientWidth) {
      if (scrollLeft + clientWidth >= scrollWidth - 1) {
        setScrollPosition('end');
      } else if (scrollLeft <= 0) {
        setScrollPosition('start');
      } else {
        setScrollPosition('scrolling');
      }
    } else {
      setScrollPosition('none');
    }
  };
  var scrollContainerRef = React.useRef(null);
  var updateScrollState = React.useCallback(function () {
    var el = scrollContainerRef.current;
    if (el) {
      if (el.scrollWidth > el.clientWidth) {
        var isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        var isAtStart = el.scrollLeft <= 0;
        if (isAtEnd) {
          setScrollPosition('end');
        } else if (isAtStart) {
          setScrollPosition('start');
        } else {
          setScrollPosition('scrolling');
        }
      } else {
        setScrollPosition('none');
      }
    }
  }, []);

  /**
   * Scroll sync effects
   */
  React.useEffect(function () {
    updateScrollState();
    window.addEventListener('resize', updateScrollState);
    return function () {
      return window.removeEventListener('resize', updateScrollState);
    };
  }, [table, updateScrollState]);
  React.useEffect(function () {
    var timeout = setTimeout(updateScrollState, 0);
    return function () {
      return clearTimeout(timeout);
    };
  }, [updateScrollState]);
  React.useEffect(function () {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [pagination.pageIndex]);
  var spinnerContainerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    opacity: isInitialLoading || isLoading ? 1 : 0,
    pointerEvents: isInitialLoading || isLoading ? 'all' : 'none',
    background: 'rgba(255, 255, 255, 0.8)',
    marginTop: '0px',
    transition: 'opacity 0.3s ease'
  };
  var noTableRows = table.getRowModel().rows.length < 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(_classes.Classes.TABLE_CONTAINER, " ").concat(_classes.Classes.TABLE_DENSITY, "-").concat(density),
    style: {
      height: tableHeight,
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '100%',
      overflowX: 'auto'
    },
    ref: scrollContainerRef,
    onScroll: enableColumnPinning ? handleScroll : undefined,
    className: "".concat(_classes.Classes.TABLE_WRAPPER, " ").concat(enableColumnPinning ? scrollPositionToClassMap[scrollPosition] : '')
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: _classes.Classes.TABLE,
    style: {
      tableLayout: tableLayout
    }
  }, /*#__PURE__*/React.createElement("thead", null, table.getHeaderGroups().map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", {
      key: headerGroup.id
    }, headerGroup.headers.map(function (header) {
      var _pinnedColumns$right;
      var _getPinnedProps = getPinnedProps(header.id),
        pinnedValue = _getPinnedProps.pinnedValue,
        pinnedClasses = _getPinnedProps.pinnedClasses,
        pinnedStyles = _getPinnedProps.pinnedStyles;
      var headerLabel = getHeaderLabel(header);
      var ariaSort = getAriaSort(header.column);
      var isData = isDataColumn(header.column);
      var truncateHeader = isHeaderTruncated(header.column);

      // We need to know if this is the first pinned right hand column, this is used to add a shadow
      // to the left of the first pinned right column
      //
      var firstPinnedRightColumn = (pinnedColumns === null || pinnedColumns === void 0 || (_pinnedColumns$right = pinnedColumns.right) === null || _pinnedColumns$right === void 0 ? void 0 : _pinnedColumns$right[0]) === header.id;
      if (header.column.id === 'checkbox') {
        return /*#__PURE__*/React.createElement("th", {
          key: header.id,
          colSpan: header.colSpan,
          "data-pinned": pinnedValue,
          "data-first-pinned-right": firstPinnedRightColumn ? 'true' : 'false',
          className: "".concat(_classes.Classes.TABLE_HEADER, " ").concat(_classes.Classes.TABLE_SCROLL_NONE, " action-column-cell ").concat(pinnedClasses),
          style: _objectSpread(_objectSpread(_objectSpread({}, pinnedStyles), getColumnWidth(header.column)), {}, {
            padding: '0 0 0 3px',
            verticalAlign: 'middle'
          }),
          scope: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: _classes.Classes.TABLE_CELL_CONTENT,
          style: {
            display: 'flex',
            alignItems: 'center',
            minHeight: '32px',
            marginLeft: '-2px'
          }
        }, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())));
      }
      return /*#__PURE__*/React.createElement("th", {
        key: header.id,
        colSpan: header.colSpan,
        "aria-sort": ariaSort,
        "data-pinned": pinnedValue,
        "data-first-pinned-right": firstPinnedRightColumn ? 'true' : 'false',
        className: "".concat(_classes.Classes.TABLE_HEADER, " ").concat(enableColumnPinning ? scrollPositionToClassMap[scrollPosition] : '', " ").concat(isData ? 'data-column-header' : 'action-column-header', " ").concat(pinnedClasses),
        onClick: header.column.getCanSort() ? function () {
          return header.column.toggleSorting();
        } : undefined,
        style: _objectSpread(_objectSpread(_objectSpread({}, pinnedStyles), getColumnWidth(header.column)), {}, {
          cursor: header.column.getCanSort() ? 'pointer' : 'default'
        }),
        scope: "col"
      }, header.column.getCanSort() ? /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
        content: "Sort by ".concat(headerLabel),
        openOnTargetFocus: false
      }, /*#__PURE__*/React.createElement(_typography.Body, {
        semiBold: true,
        style: truncateHeader ? {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        } : {},
        title: "Sort by ".concat(headerLabel)
      }, header.column.getIsSorted() && /*#__PURE__*/React.createElement(_Icon.Icon16, {
        fill: _colors.Colors.GREEN_50,
        icon: header.column.getIsSorted() === 'desc' ? _iconNames.IconNames16.ARROW_DOWN : _iconNames.IconNames16.ARROW_UP,
        style: {
          marginRight: '0.6em'
        }
      }), (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()))) : /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
        content: headerLabel,
        openOnTargetFocus: false
      }, /*#__PURE__*/React.createElement(_typography.Body, {
        semiBold: true,
        style: truncateHeader ? {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        } : {}
      }, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()))));
    }));
  })), /*#__PURE__*/React.createElement("tbody", null, isInitialLoading ? /*#__PURE__*/React.createElement("tr", {
    className: _classes.Classes.TABLE_ROW
  }, /*#__PURE__*/React.createElement("td", {
    className: "".concat(_classes.Classes.TABLE_CELL, " data-column-cell")
  }, "Loading...")) : hasVisibleDataColumns ? noTableRows ? /*#__PURE__*/React.createElement("tr", {
    className: _classes.Classes.TABLE_ROW
  }, /*#__PURE__*/React.createElement("td", {
    className: "".concat(_classes.Classes.TABLE_CELL, " data-column-cell"),
    style: {
      paddingTop: '40px',
      paddingBottom: '40px'
    },
    colSpan: table.getFlatHeaders().length
  }, "There is no data to display.")) : table.getRowModel().rows.map(function (row, rowIndex) {
    var isExpanded = row.getIsExpanded();
    var isSelected = row.getIsSelected();
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: row.id
    }, /*#__PURE__*/React.createElement("tr", {
      className: getRowClass({
        isExpanded: isExpanded,
        isSelected: isSelected
      }),
      style: {
        cursor: 'pointer'
      }
    }, row.getVisibleCells().map(function (cell) {
      var _pinnedColumns$right2, _cell$column;
      var _getPinnedProps2 = getPinnedProps(cell.column.id),
        pinnedValue = _getPinnedProps2.pinnedValue,
        pinnedClasses = _getPinnedProps2.pinnedClasses,
        pinnedStyles = _getPinnedProps2.pinnedStyles;
      var isData = isDataColumn(cell.column);
      var firstPinnedRightColumn = (pinnedColumns === null || pinnedColumns === void 0 || (_pinnedColumns$right2 = pinnedColumns.right) === null || _pinnedColumns$right2 === void 0 ? void 0 : _pinnedColumns$right2[0]) === (cell === null || cell === void 0 || (_cell$column = cell.column) === null || _cell$column === void 0 ? void 0 : _cell$column.id);
      // Custom checkbox cell with shift-select
      if (cell.column.id === 'checkbox') {
        return /*#__PURE__*/React.createElement("td", {
          key: cell.id,
          "data-pinned": pinnedValue,
          "data-first-pinned-right": firstPinnedRightColumn ? 'true' : 'false',
          className: "".concat(_classes.Classes.TABLE_CELL, " ").concat(_classes.Classes.TABLE_SCROLL_NONE, " ").concat(enableColumnPinning ? scrollPositionToClassMap[scrollPosition] : '', " action-column-cell ").concat(pinnedClasses),
          style: _objectSpread(_objectSpread({}, pinnedStyles), getColumnWidth(cell.column)),
          tabIndex: 0
        }, /*#__PURE__*/React.createElement("div", {
          className: _classes.Classes.TABLE_CELL_CONTENT
        }, /*#__PURE__*/React.createElement(_Checkbox.Checkbox, {
          checked: isSelected,
          onChange: function onChange(e) {
            var mouseEvent = e.nativeEvent;
            if (mouseEvent.shiftKey && lastSelectedIndexRef.current !== null) {
              var start = Math.min(lastSelectedIndexRef.current, rowIndex);
              var end = Math.max(lastSelectedIndexRef.current, rowIndex);
              var shouldUnselect = row.getIsSelected();
              for (var i = start; i <= end; i += 1) {
                table.getRowModel().rows[i].toggleSelected(!shouldUnselect);
              }
            } else {
              row.toggleSelected(!row.getIsSelected());
            }
            lastSelectedIndexRef.current = rowIndex;
            // For debugging:Log selected rows after selection change
            // const selectedRows = table.getRowModel().rows.filter(r => r.getIsSelected());
            // console.log('Selected rows:', selectedRows.map(r => r.id));
          }
        })));
      }
      return /*#__PURE__*/React.createElement("td", {
        key: cell.id,
        "data-pinned": pinnedValue,
        "data-first-pinned-right": firstPinnedRightColumn ? 'true' : 'false',
        className: "".concat(_classes.Classes.TABLE_CELL, " ").concat(enableColumnPinning ? scrollPositionToClassMap[scrollPosition] : '', " ").concat(isData ? 'data-column-cell' : 'action-column-cell', " ").concat(pinnedClasses),
        style: _objectSpread(_objectSpread({}, pinnedStyles), getColumnWidth(cell.column)),
        tabIndex: cell.column.id === 'expand' ? -1 : 0
      }, /*#__PURE__*/React.createElement("div", {
        className: _classes.Classes.TABLE_CELL_CONTENT
      }, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())));
    })), isExpanded && expandedRowContent && /*#__PURE__*/React.createElement("tr", {
      className: "".concat(_classes.Classes.TABLE_ROW, " ").concat(_classes.Classes.TABLE_EXPANDED_ROW)
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: table.getVisibleLeafColumns().length,
      className: _classes.Classes.TABLE_EXPANDED_ROW_CONTENT
    }, expandedRowContent(row.original))));
  }) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: Math.max(1, table.getVisibleLeafColumns().length)
  }, /*#__PURE__*/React.createElement(_Empty.Empty, null, /*#__PURE__*/React.createElement(_typography.Lead, {
    muted: true
  }, "There are no columns selected")))))))), showPagination && !noTableRows && /*#__PURE__*/React.createElement(_Pagination.Pagination, {
    table: table,
    pageSize: pagination.pageSize,
    pageIndex: pagination.pageIndex,
    setPageSize: function setPageSize(pageSizeValue) {
      return table.setPageSize(pageSizeValue);
    },
    dataLength: manualPagination ? totalRows : table.getFilteredRowModel().rows.length
  }), /*#__PURE__*/React.createElement("div", {
    style: spinnerContainerStyle
  }, (isLoading || isInitialLoading) && /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignContent: "center",
    justifyContent: "center",
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Spinner.Spinner, null))));
}